import { render, staticRenderFns } from "./ChartUsersVideos.vue?vue&type=template&id=24d0440e"
import script from "./ChartUsersVideos.vue?vue&type=script&lang=js"
export * from "./ChartUsersVideos.vue?vue&type=script&lang=js"
import style0 from "./ChartUsersVideos.vue?vue&type=style&index=0&id=24d0440e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports